import type { KeyNameFields } from "@/services/legalsService";

export const useLegalsFields = () => {
    const fields:{ label: string; id: KeyNameFields; type: 'text' | 'textarea' | 'dropdown' | 'radio' | 'colorPicker' | 'richText', placeholder: string, readOnly: boolean, options?: any[] }[] = [
        {
            label: 'Nombre legal*',
            id: 'name',
            type: 'text',
            placeholder: 'Legal-001',
            readOnly: true
        },
        {
            label: 'Color legal*',
            id: 'color',
            type: 'colorPicker',
            placeholder: 'Color legal',
            readOnly: false
        },
        {
            label: 'Texto legal*',
            id: 'legal_text',
            type: 'richText',
            placeholder: 'Texto legal válido',
            readOnly: false
        },
    ]

    return {
        fields
    }
}
